import { Search,SainikSchemeApplicationModel } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-applications-grid',
  templateUrl: './applications-grid.component.html',
  styleUrls: ['./applications-grid.component.css']
})
export class ApplicationsGridComponent implements OnInit {
  maintitle="SchemesApplications";
  title = "Applications List";  
  sainikSchemeApplications;  
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  s: Search;
  message : boolean;
  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllApplicationByTheUser(this.itemsPerPage, 1);
  }


  SetUrl(applicationId:any,mode:any,AppFromuserId:any)
  {
    localStorage.setItem('applicationId',applicationId);
    localStorage.setItem('mode', mode);
    localStorage.setItem('FromuserId', AppFromuserId);
  } 

  pageChanged(pageNumber:number)
  {    
    this.GetAllApplicationByTheUser(this.itemsPerPage, pageNumber);
  }
  
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {    
    this.GetAllApplicationByTheUser(this.itemsPerPage, pageNo);
  }


  GetAllApplicationByTheUser(itemsPerPage: number, pageNo: number) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllApplicationByTheUser(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.sainikSchemeApplications=data.sainikSchemeApplicationModels;         
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });

  }
}



// WEBPACK FOOTER //
// ./src/app/schemes/applications-grid/applications-grid.component.ts